//FILTRI
export const LABEL_Filter_Apply                 = {
    it : "Applica",
    en : "Apply"
};
export const LABEL_Filter_RemoveFilters         = {
    it : "Rimuovi Filtri",
    en : "Remove Filters"
};
export const LABEL_Filter_OnlyActive            = { 
    it : "Solo Attivi",
    en : "Only Active"
};
export const LABEL_Filter_OnlyDeleted           = {
    it : "Solo Cancellati",
    en : "only Deleted"
};
export const LABEL_Filter_OnlyDefinitive        = {
    it : "Solo Definitivi",
    en : "Only Definitive"
};
export const LABEL_Filter_OnlyEditable          = {
    it : "Solo Modificabili",
    en : "Only Editable"
};
export const LABEL_Filter_OnlyMandatory         = {
    it : "Solo Obbligatory",
    en : "Only Mandatory"
};
export const LABEL_Filter_OnlyOptional          = {
    it : "Solo Opzionali",
    en : "Only Optional"
};
export const LABEL_Filter_OnlyEmailConfirmed    = {
    it : "Solo Email Confermate",
    en : "Only Confirmed Email"
};
export const LABEL_Filter_OnlyEmailNotConfirmed = {
    it : "Solo Email Non Confermate",
    en : "Only Not Confirmed Email"
};
export const LABEL_Filter_OnlyLockedUser        = {
    it : "Solo Utenti Bloccati",
    en : "Blocked users only"
};
export const LABEL_Filter_OnlyEnabledUser       = {
    it : "Solo Utenti Abilitati",
    en : "Enabled users only"
};
export const LABEL_Filter_Either                = { 
    it : "Entrambi",
    en : "Either"
};
export const LABEL_Set_As_Preferred             = {
    it : "Setta come predefinita",
    en : "Set As Preferred"
};
export const LABEL_Set_As_Default             = {
    it : "Setta come Predefinita",
    en : "Set As Default"
};
//NON TROVATO
export const LABEL_NotFound_Tables              ={
    it : "Nessuna Tabella Trovata" ,
    en : "Tables Not Found"
}; 
//ETICHETTE
export const LABEL_FileName            = {
    it : "Nome File",
    en : "File Name"
}
export const LABEL_UsernameValid       = {
    it : "Username Valido",
    en : "Valid Username"
};
export const LABEL_UsrAndPswError      = {
    it : "Username o Password Errati",
    en : "Invalid Username Or Password"
};
export const LABEL_NewUser             = {
    it : "Nuovo Utente",
    en : "New User"
};
export const LABEL_AssociateUser       = {
    it : "Associa Un Utente",
    en : "Associate User"
};
export const LABEL_Confirm             = {
    it : "Conferma",
    en : "Confirm"
};
export const LABEL_Printer             = {
    it : "Stampante",
    en : "Printer"
};
export const LABEL_Payment             = {
    it : "Pagamento",
    en : "Payment"
};
export const LABEL_PaymentOK           = {
    it : "Pagamento Effettuato Con Successo",
    en : "Payment Made Successfully"
};
export const LABEL_Loked               = {
    it : "Bloccati",
    en : "Loked"
};
export const LABEL_True                = {
    it : "Vero",
    en : "True",
};
export const LABEL_False               = {
    it : "Falso",
    en : "False",
};
export const LABEL_TableStructureModify= {
    it : "Modifica Struttura Tabella",
    en : "Edit Table Structure",
};
export const LABEL_TableValuesModify   = {
    it : "Modifica Valori Tabella",
    en : "Edit Table Values",
};
export const LABEL_ColumnsNotFound     = {
    it : "Nessuna colonna trovata",
    en : "No Columns Found",
};
export const LABEL_TableColumns        = {
    it : "Colonne Tabella",
    en : "Table Columns",
};
export const LABEL_Net                 = {
    it : "Netto",
    en : "Net",
};
export const LABEL_User                = {
    it : "Utente",
    en : "User",
};
export const LABEL_LogicalOperator     = {
    it : "Operatore Logico",
    en : "Logical Operator",
};
export const LABEL_Field               = {
    it : "Campo",
    en : "Field",
};
export const LABEL_NexStep             = {
    it : "Avanti",
    en : "Forward",
};
export const LABEL_FillTable           = {
    it : "Inserisci Valori Tabella",
    en : "Insert Table Values",
};
export const LABEL_ChooseVersione      = {
    it : "Seleziona Versione",
    en : "Select Version",
};
export const LABEL_BusinessName        = {
    it : "Ragione Sociale",
    en : "Business Name",
};
export const LABEL_SignIn              = {
    it : "Registrati",
    en : "SignIn",
};
export const LABEL_GreatherLengthOf    = {
    it : "Lunghezza maggiore di ",
    en : "The Length Is Greater Than",
};
export const LABEL_Yes                 = {
    it : "Si",
    en : "Yes",
};
export const LABEL_No                  = {
    it : "No",
    en : "No",
};
export const LABEL_All                 = {
    it : "Tutti",
    en : "All",
};
export const LABEL_Required            = {
    it : "Obbligatorio",
    en : "Required",
};
export const LABEL_NoResult            = {
    it : "Nessun Risultato",
    en : "No Result",
};
export const LABEL_InvalidValue        = {
    it : "Valore non Valido",
    en : "Invalid Value",
};
export const LABEL_CanNotConfirmEmail  = {
    it : "Impossibile confermare l'Email",
    en : "Email confirmation failed",
};
export const LABEL_EmailConfirmed      = {
    it : "Email Confermata",
    en : "Email Confirmed",
};
export const LABEL_GoToLogin           = {
    it : "Vai Al Login",
    en : "Go To Login",
};
export const LABEL_Filters             = {
    it : "Filtri",
    en : "Filters",
};
export const LABEL_Close               = {
    it : "Chiudi",
    en : "Close",
};
export const LABEL_Cancel              = {
    it : "Annulla",
    en : "Cancel",
};
export const LABEL_Save                = {
    it : "Salva",
    en : "Save",
};
export const LABEL_Send                = {
    it : "Invia",
    en : "Send",
};
export const LABEL_Deleted             = {
    it : "Cancellato",
    en : "Deleted",
};
export const LABEL_Delete              = {
    it : "Cancella",
    en : "Delete",
};
export const LABEL_CreatedBy           = {
    it : "Creato Da",
    en : "Created By",
};
export const LABEL_OrderBy             = {
    it : "Ordina Per",
    en : "Sort By",
};
export const LABEL_Strict              = {
    it : "Fiscale",
    en : "Fiscal",
};
export const LABEL_NoExpiryDate        = {
    it : "Nessuna Data Di Scadenza",
    en : "No due date",
};
export const LABEL_Date                = {
    it : "Data",
    en : "Date",
};
export const LABEL_Decimal             = {
    it : "Decimale",
    en : "Decimal",
};
export const LABEL_Integer             = {
    it : "Intero",
    en : "Integer",
};
export const LABEL_Table               = {
    it : "Tabella",
    en : "Table",
};
export const LABEL_Libra               = {
    it : "Bilancia",
    en : "Weighbridge",
};
export const LABEL_Text                = {
    it : "Testo",
    en : "Text",
};
export const LABEL_VeroFalso           = {
    it : "Vero / Falso",
    en : "True / False",
};
export const LABEL_ComeBack            = {
    it : "Torna Indetro",
    en : "Come Back",
};
export const LABEL_Weigh               = {
    it : "Pesata",
    en : "Weighing",
};
export const LABEL_DateStart           = {
    it : "Data Inizio",
    en : "Start date",
};
export const LABEL_DateEnd             = {
    it : "Data Fine",
    en : "End date",
};
export const LABEL_MinimumWeight       = {
    it : "Peso Minimo",
    en : "Min Weighing",
};
export const LABEL_MaximumWeight       = {
    it : "Peso Massimo",
    en : "Max Weighing",
};
export const LABEL_FirstWeight         = {
    it : "Primo Peso",
    en : "First Weighing",
};
export const LABEL_SecondWeight        = {
    it : "Secondo Peso",
    en : "Second Weighing",
};
export const LABEL_FirstWeightDate     = {
    it : "Data Primo Peso",
    en : "First weighing date & time",
};
export const LABEL_SecondWeightDate    = {
    it : "Data Secondo Peso",
    en : "Second weighing date & time",
};
export const LABEL_FirstMPP            = {
    it : "Primo MPP",
    en : "First MPP",
};
export const LABEL_SecondMPP           = {
    it : "Secondo MPP",
    en : "Second MPP",
};
export const LABEL_Information         = {
    it : "Informazioni",
    en : "Information",
};
export const LABEL_Blocked             = {
    it : "Bloccato",
    en : "Blocked",
};
export const LABEL_Confirmed           = {
    it : "Confermato",
    en : "Confirmed",
};
export const LABEL_Role                = {
    it : "Ruolo",
    en : "Role",
};
export const LABEL_Days                = {
    it : "Giorni",
    en : "Days",
};
export const LABEL_Description         = {
    it : "Descrizione",
    en : "Description",
};
export const LABEL_Settings            = {
    it : "Impostazioni",
    en : "Settings",
};
export const LABEL_Range               = {
    it : "Intervallo",
    en : "Interval",
};
export const LABEL_Length              = {
    it : "Lunghezza",
    en : "Length",
};
export const LABEL_MaxLength           = {
    it : "Lunghezza Massima",
    en : "Max Length",
};
export const LABEL_MinLength           = {
    it : "Lunghezza Minima",
    en : "Min Length",
};
export const LABEL_DefaultValue        = {
    it : "Valore di Default",
    en : "Default Value",
};
export const LABEL_EditableInWeighing  = {
    it : "Sempre Modificabile",
    en : "Always Editable",
};
export const LABEL_CustomFieldTipology = {
    it : "Tipo Campo Personalizzato",
    en : "Custom Field Type",
};
export const LABEL_Editable            = {
    it : "Modificabile",
    en : "Editable",
};
export const LABEL_UseMpp              = {
    it : "Utilizzo Mpp",
    en : "MPP Purposes",
};
export const LABEL_Periodicals         = {
    it : "Periodica",
    en : "Periodic",
};
export const LABEL_Name                = {
    it : "Nome",
    en : "Name",
};
export const LABEL_Piva                = {
    it : "Partita Iva",
    en : "VAT number",
};
export const LABEL_Address             = {
    it : "Indirizzo",
    en : "Address",
};
export const LABEL_City                = {
    it : "Citta'",
    en : "City",
};
export const LABEL_Phone               = {
    it : "Telefono",
    en : "Phone Number",
};
export const LABEL_Email               = {
    it : "Email",
    en : "Email",
};
export const LABEL_District            = {
    it : "Provincia",
    en : "Province",
};
export const LABEL_Cap                 = {
    it : "CAP",
    en : "Postal Code",
};
export const LABEL_WebPage             = {
    it : "Pagina Web",
    en : "Web Page",
};
export const LABEL_Ip                  = {
    it : "IP",
    en : "IP",
};
export const LABEL_SerialNumber        = {
    it : "Matricola",
    en : "Serial No.",
};
export const LABEL_Port                = {
    it : "Porta",
    en : "Port",
};
export const LABEL_Alias               = {
    it : "Alias",
    en : "Nickname",
};
export const LABEL_Model               = {
    it : "Modello",
    en : "Model",
};
export const LABEL_Brand               = {
    it : "Marca",
    en : "Brand",
};
export const LABEL_Tipology            = {
    it : "Tipologia",
    en : "Tipology",
};
export const LABEL_Holding             = {
    it : "Holding",
    en : "Holding",
};
export const LABEL_Company             = {
    it : "Azienda",
    en : "Company",
};
export const LABEL_CompanyDetails      = {
    it : "Dettaglio Azienda",
    en : "Company Detail",
};
export const LABEL_Plant               = {
    it : "Impianto",
    en : "Plant",
};
export const LABEL_DIALOG_PlantDetails = {
    it : "Dettaglio Azienda",
    en : "Company Detail",
};
export const LABEL_MppPort             = {
    it : "Porta MPP",
    en : "MPP Port",
};
export const LABEL_MppAlias            = {
    it : "Alias MPP",
    en : "Nickname MPP",
};
export const LABEL_Label               = {
    it : "Etichetta",
    en : "Label",
};
export const LABEL_SelectLanguage      = {
    it : "Seleziona Lingua",
    en : "Select Language",
};
export const LABEL_LanguagedChange      = {
    it : "Cambia Lingua",
    en : "Change Language",
};
export const LABEL_Password            = {
    it : "Password",
    en : "Password",
};
export const LABEL_InvalidPassword     = {
    it : "Password Non Valida",
    en : "Invalid Password",
};
export const LABEL_LengthRequired      = {
    it : "Lunghezza Richiesta",
    en : "Required Length",
};
export const LABEL_PasswordNew         = {
    it : "Nuova Password",
    en : "New Password",
};
export const LABEL_PasswordConfirm     = {
    it : "Conferma Nuova Password",
    en : "Confirm New Password",
};
export const LABEL_PasswordOKConfirm   = {
    it : "Conferma Password",
    en : "Confirm Password",
};
export const LABEL_PasswordChange      = {
    it : "Cambia Password",
    en : "Change Password",
};
export const LABEL_PasswordNotEquals   = {
    it : "Password Non Corrispondenti",
    en : "Password Do Not Match",
};
export const LABEL_PasswordModelError  = {
    it : "La password deve contenere almeno due caratteri",
    en : "The password must contain at least two characters",
};
export const LABEL_PasswordOld         = {
    it : "Password Attuale",
    en : "Current Password",
};
export const LABEL_Username            = {
    it : "Username",
    en : "Username",
};
export const LABEL_ForgotPassword      = {
    it : "Password Dimenticata?",
    en : "Forgot Password?",
};
export const LABEL_Login               = {
    it : "Login",
    en : "Login",
};
export const LABEL_Logout              = {
    it : "Esci",
    en : "Logout",
};
export const LABEL_PasswordRecovery    = {
    it : "Recupera Password",
    en : "Password Recovery",
};
export const LABEL_StartExpiration     = {
    it : "Data Inizio Scadenza",
    en : "Due date starts on:",
};
export const LABEL_EndExpiration       = {
    it : "Data Fine Scadenza",
    en : "Due date ends on:",
};
export const LABEL_Expiration          = {
    it : "Scadenza",
    en : "Expiration",
};
export const LABEL_NumberDays          = {
    it : "Numero Giorni",
    en : "Days Number",
};
export const LABEL_ExpiredLicense      = {
    it : "Licenza Scaduta",
    en : "Expired License",
};
export const LABEL_Expiring            = {
    it : "In Scadenza",
    en : "Expiring",
};
export const LABEL_MinimumValue        = {
    it : "Valore minimo",
    en : "Min Value",
};
export const LABEL_MaximumValue        = {
    it : "Valore massimo",
    en : "Max Value",
};
export const LABEL_Invalid_Cap         = {
    it : "Cap Non Valido",
    en : "Invalid Postal Code",
};
export const LABEL_Invalid_Email       = {
    it : "Email Non Valida",
    en : "Invalid Email",
};
export const LABEL_Invalid_Piva        = {
    it : "P.IVA / CF Non Valido",
    en : "Invalid VAT number",
};
export const LABEL_TableStructure      = {
    it : "Struttura Tabella : ",
    en : "Table Structure : ",
};
export const LABEL_FieldType           = {
    it : "Tipo Campo",
    en : "Field Type",
};
export const LABEL_FirstWeighting      = {
    it : "Prima Pesata",
    en : "First Weighing",
};
export const LABEL_SecondWeighting     = {
    it : "Seconda Pesata",
    en : "Second Weighing",
};
export const LABEL_FilterSet           = {
    it : "Filtri Settati",
    en : "Filters Set",
};
export const LABEL_System              = {
    it : "Sistema",
    en : "System",
};
export const LABEL_Download            = {
    it : "Scarica",
    en : "Download"
};
export const LABEL_ExportWeighings     = {
    it : "Esporta : Pesate",
    en : "Export : Weighings" 
}
export const LABEL_Number              = {
    it : "Numero",
    en : "Number"
}
export const LABEL_DonTHaveAccount     = {
    it : "Non Hai Un Account?",
    en : "Don't Have An Account?"
}
//INSERISCI
export const LABEL_Enter_BusinessName    = {
    it : "Inserisci la Ragione Sociale", 
    en : "Insert Business Name",
};
export const LABEL_Enter_Description     = {
    it : "Inserisci la descrizione",
    en : "Insert Description",
};
export const LABEL_Enter_Name            = {
    it : "Inserisci il nome",
    en : "Insert Name",
};
export const LABEL_Enter_Piva            = {
    it : "Inserisci la partita Iva",
    en : "Insert VAT Number",
};
export const LABEL_Enter_Address         = {
    it : "Inserisci l'indirizzo",
    en : "Insert Address",
};
export const LABEL_Enter_City            = {
    it : "Inserisci la citta'",
    en : "Insert City",
};
export const LABEL_Enter_Phone           = {
    it : "Inserisci il numero di telefono",
    en : "Insert Phone Number",
};
export const LABEL_Enter_Email           = {
    it : "Inserisci l' email",
    en : "Insert Email",
};
export const LABEL_Enter_District        = {
    it : "Inserisci la provincia",
    en : "Province",
};
export const LABEL_Enter_Cap             = {
    it : "Inserisci il cap",
    en : "Insert Postal Code",
};
export const LABEL_Enter_WebPage         = {
    it : "Inserisci l'indirizzo della pagina web",
    en : "Insert Web Page Address",
};
export const LABEL_Enter_Ip              = {
    it : "Inserisci l'indirizzo IP",
    en : "Insert IP Address",
};
export const LABEL_Enter_SerialNumber    = {
    it : "Inserisci la Matricola",
    en : "Insert Serial No.",
};
export const LABEL_Enter_Port            = {
    it : "Inserisci la porta",
    en : "Insert Port",
};
export const LABEL_Enter_Alias           = {
    it : "Inserisci l'alias",
    en : "Insert Nikname",
};
export const LABEL_Enter_Model           = {
    it : "Inserisci il modello",
    en : "Insert Model",
};
export const LABEL_Enter_Tipology        = {
    it : "Inserisci la tipologia",
    en : "Insert Tipology",
};
export const LABEL_Enter_Company         = {
    it : "Inserisci l'Azienda",
    en : "Insert Company",
};
export const LABEL_Enter_MppPort         = {
    it : "Inserisci la porta MPP",
    en : "Insert MPP Port",
};
export const LABEL_Enter_MppAlias        = {
    it : "Inserisci l'alias MPP",
    en : "Insert MPP Nickname",
};
export const LABEL_Enter_Label           = {
    it : "Inserisci l'etichetta",
    en : "Insert Label",
};
export const LABEL_Enter_DefaultValue    = {
    it : "Inserisci il valore predefinito",
    en : "Insert Default Value",
};
export const LABEL_Enter_Length          = {
    it : "Inserisci la lughezza",
    en : "Enter The Length",
};
export const LABEL_Enter_MaxLength       = {
    it : "Inserisci la lunghezza massima",
    en : "Enter The Maximum Length",
};
export const LABEL_Enter_MinLength       = {
    it : "Inserisci la lunghezza minima",
    en : "Enter The Minimum Length",
};
export const LABEL_Enter_CustomFieldName = {
    it : "Inserisci il nome del campo",
    en : "Insert Custom Field Name",
};
export const LABEL_Enter_Password        = {
    it : "Inserisci la password",
    en : "Insert Password",
};
export const LABEL_Enter_Username        = {
    it : "Inserisci l'username",
    en : "Insert Username",
};
export const LABEL_Enter_MinimumWeight   = {
    it : "Inserisci il peso minimo",
    en : "Insert Min Weight",
};
export const LABEL_Enter_MaximumWeight   = {
    it : "Inserisci il peso massimo",
    en : "Insert Max Weight",
};
export const LABEL_Enter_MinimumValue    = {
    it : "Inserisci il valore minimo",
    en : "Insert Min Value",
};
export const LABEL_Enter_MaximumValue    = {
    it : "Inserisci il valore massimo",
    en : "Insert Max Value",
};
export const LABEL_Enter_Value           = {
    it : "Inserisci un valore",
    en : "Insert A Value",
};
export const LABEL_Enter_ValidUsername   = {
    it : "Inserisci un username valido",
    en : "Insert A Valid Username ",
};
//NOMI PAGINE
export const LABEL_PAGE_UpgradePro                = {
    it : "Passa a Pro",
    en : "Upgrade to Pro"
};
export const LABEL_PAGE_UpgradeCloud              = {
    it : "Passa a Cloud",
    en : "Upgrade to CLOUD"
};
export const LABEL_PAGE_Company                   = {
    it : "Aziende",
    en : "Companies"
};
export const LABEL_PAGE_Libra                     = {
    it : "Bilance",
    en : "Weighbridges"
};
export const LABEL_PAGE_CustomPrints              = {
    it : "Stampe Personalizzate",
    en : "Custom Prints"
};
export const LABEL_PAGE_CustomPrintsA             = {
    it : "Stampe P.",
    en : "C. Prints"
};
export const LABEL_PAGE_Printer                   = {
    it : "Stampanti",
    en : "Printers"
};
export const LABEL_PAGE_CustomTables              = {
    it : "Tabelle Personalizzate",
    en : "Custom Tables"
};
export const LABEL_PAGE_CustomFields              = {
    it : "Campi Personalizzati",
    en : "Custom Fields"
};
export const LABEL_PAGE_CustomTablesA             = {
    it : "Tabelle P.",
    en : "C. Tables"
};
export const LABEL_PAGE_CustomFieldsA             = {
    it : "Campi P.",
    en : "C. Fields"
};
export const LABEL_PAGE_Libras                    = {
    it : "Bilance",
    en : "Weighbridges"
};
export const LABEL_PAGE_Weigh                     = {
    it : "Pesate",
    en : "Weighings"
};
export const LABEL_PAGE_Operators                 = {
    it : "Operatori",
    en : "Operator"
};
export const LABEL_PAGE_Holding                   = {
    it : "Holding",
    en : "Holding"
};
export const LABEL_PAGE_Settings                  = {
    it : "Impostazioni",
    en : "Settings"
};
export const LABEL_PAGE_Plant                     = {
    it : "Impianti",
    en : "Plants"
};
export const LABEL_PAGE_ErrorConnection           = {
    it : "Impossibile Stabilire Una Connessione",
    en : "Connection Errore"
};
//SELEZIONI
export const LABEL_Choose_Value                   = {
    it : "Seleziona Un Valore",
    en : "Select A Value"
};
export const LABEL_Choose_FileType                = {
    it : "Seleziona Tipo File",
    en : "Select File Type"
};
export const LABEL_Choose_Plant                   = {
    it : "Seleziona Impianto",
    en : "Select A Plant"
};
export const LABEL_Choose_Company                 = {
    it : "Seleziona Azienda",
    en : "Select A Company"
};
export const LABEL_Choose_Holding                 = {
    it : "Seleziona Holding",
    en : "Select A Holding"
};
export const LABEL_Choose_Tipology                = {
    it : "Seleziona la tipologia",
    en : "Select A Tipology"
};
export const LABEL_Choose_Model                   = {
    it : "Seleziona il Modello",
    en : "Select Models"
};
export const LABEL_Choose_Brand                   = {
    it : "Seleziona la marca",
    en : "Select Brand"
};
export const LABEL_Choose_Table                   = {
    it : "Seleziona una Tabella",
    en : "Select A Table"
};
export const LABEL_Choose_Field                   = {
    it : "Seleziona un Campo",
    en : "Select A Field"
};
//ALERT
export const LABEL_ALERT_Choose_Plant             = {
    it : "Ogni bilancia deve essere collegata ad un Impianto per poter essere creata. Quindi dopo aver selezionato un'Azienda, seleziona un Impianto e riprova.",
    en : "Each weighbridge must be linked to a plant in order to be created. So, after selecting a company, please select a plant and try again."
};
export const LABEL_ALERT_Choose_Plant_Printer     = {
    it : "Ogni stampante deve essere collegata ad un Impianto per poter essere creata. Seleziona un Impianto e riprova.",
    en : "Each printer must be linked to a plant in order to be created. Please select a plant and try again."
};
//DIALOG
export const LABEL_DIALOG_CompanyNew              = {
    it : "Nuova Azienda",
    en : "New Company"
};
export const LABEL_DIALOG_CompanyModify           = {
    it : "Modifica Azienda",
    en : "Edit Company"
};
export const LABEL_DIALOG_CompanyDetails          = {
    it : "Dettaglio Azienda",
    en : "Company Detail"
};
export const LABEL_DIALOG_LibraNew                = {
    it : "Nuova Bilancia",
    en : "New Weighbridge"
};
export const LABEL_DIALOG_LibraModify             = {
    it : "Modifica Bilancia",
    en : "Modify Weighbridge"
};
export const LABEL_DIALOG_LibraDetail             = {
    it : "Dettaglio Bilancia",
    en : "Weighbridge Detail"
};
export const LABEL_DIALOG_CustomFieldNew          = {
    it : "Nuovo Campo Personalizzato",
    en : "New Custom Field"
};
export const LABEL_DIALOG_CustomFieldModify       = {
    it : "Modifica Campo Personalizzato",
    en : "Edit Custom Field"
};
export const LABEL_DIALOG_CustomFieldDetails      = {
    it : "Dettaglo Campo Personalizzato",
    en : "Custom Field Detail"
};
export const LABEL_DIALOG_PrinterNew              = {
    it : "Nuova Stampante",
    en : "New Printer"
};
export const LABEL_DIALOG_PrinterModify           = {
    it : "Modifica Stampante",
    en : "Edit Printer"
};
export const LABEL_DIALOG_PrinterDetail           = {
    it : "Dettaglio Stampante",
    en : "Printer Detail"
};
export const LABEL_DIALOG_HoldingNew              = {
    it : "Nuova Holding",
    en : "New Holding"
};
export const LABEL_DIALOG_HoldingModify           = {
    it : "Modifica Holding",
    en : "Edit Holding"
};
export const LABEL_DIALOG_HoldingDetail           = {
    it : "Dettaglio Holding",
    en : "Holding Details"
};
export const LABEL_DIALOG_TableNew                = {
    it : "Nuova Tabella Personalizzata",
    en : "New Custom Table"
};
export const LABEL_DIALOG_TableModify             = {
    it : "Modifica Tabella Personalizzata",
    en : "Edit Custom Table"
};
export const LABEL_DIALOG_TableDetail             = {
    it : "Dettaglio Tabella Personalizzata",
    en : "Custom Table Detail"
};
export const LABEL_DIALOG_PlantNew                = {
    it : "Nuovo Impianto",
    en : "New Plant"
};
export const LABEL_DIALOG_PlantModify             = {
    it : "Modifica Impianto",
    en : "Edit Plant"
};
export const LABEL_DIALOG_PlantDetail             = {
    it : "Dettaglio Impianto",
    en : "Plant Detail"
};
export const LABEL_DIALOG_CONTENT_RecoverPassword = {
    it : "Una volta inserita l'email e effettuato un click sul tasto INVIA, verranno inoltrate le sue credenziali all'email indicata.", 
    en : "Once you add your email and click on the SUBMIT button, your login info will be sent to the indicated email."
};
export const LABEL_DIALOG_UserNew                 = {
    it : "Nuovo Utente",
    en : "New User"
};
export const LABEL_DIALOG_UserModify              = {
    it : "Modifica Utente",
    en : "Edit User"
};
export const LABEL_ALERT_Plant_ChooseCompany      = {
    it : "Ogni impianto deve essere collegato ad un Azienda per poter essere creato. Seleziona un Azienda e riprova.",
    en : "Each plant must be linked to a company in order to be created. Please select a company and try again."
};
export const LABEL_DIALOG_Weigh_Details           = {
    it : "Dettaglio Pesata",
    en : "Weighing Detail"
};
export const LABEL_DIALOG_DELETE_Body             = {
    it : "Premere su CONFERMA per cancellare ",
    en : "Click on CONFIRM to cancel"
};
export const LABEL_DIALOG_UserNew_Payment         = {
    it : "Procedi con il pagamento per poter aggiungere un nuovo utente",
    en : "Proceed with payment in order to add a new user"
};

export const LABEL_PAGE_HOME_Bilapp   = {
    it : "BilApp",
    en : "BilApp"
};
export const LABEL_PAGE_HOME_Versions = {
    it : "Versioni",
    en : "Version"
};
export const LABEL_PAGE_HOME_Images   = {
    it : "Immagini",
    en : "Images"
};
export const LABEL_PAGE_HOME_Videos   = {
    it : "Video",
    en : "Videos"
};
export const LABEL_PAGE_HOME_WhatIs   = {
    it : "Cos'e' BilApp?",
    en : "What is BilApp?"
};
export const LABEL_PAGE_HOME_Portal   = {
    it : "Portale Web",
    en : "Web Portal"
};
export const LABEL_DownloadNow = {
    it : "Scarica Ora",
    en : "Download Now"
};
export const LABEL_SignInNow   = {
    it : "Registrati Ora",
    en : "Signin Now"
};



// WEBPACK FOOTER //
// ./src/Utils/Strings/Labels.js